import {gql, useMutation} from "@apollo/client";

const BULK_ADD_GAMES_MUTATION = gql`
mutation AddGamesBulk($games: [AddGameInput!]!) {
  addGamesBulk(games: $games) {
    success
    createdGames
    errors
    message
  }
}

`;

export default function AddGamesBulkMutation() {
    return useMutation(BULK_ADD_GAMES_MUTATION);
}